import { render, staticRenderFns } from "./confirm-submission-modal.vue?vue&type=template&id=64f4aee4"
import script from "./confirm-submission-modal.vue?vue&type=script&lang=js"
export * from "./confirm-submission-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports